<script>
export default {
    name: "ProgressDetails",

    data() {

        return {
            patient: {},
            viewBill: false,
            visits: [],
        };
    },

    props: {
        other: {
            type: Boolean,
            default: false,
        },
        showModal: Boolean,
        investigation: Object,
        consultantDetails: Object,
    },

    methods: {

        printReceipt(patientId, receiptNo) {

            window.open(
                `/billing/receipt-invoice/print/${patientId}/${receiptNo}`, 
                '_blank', `ReceiptCash`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        fetchPatient() {
            const patientId = this.investigation.patientID || this.investigation.patientId;

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${patientId}`)
                .then(response => {
                    this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchVisits() {
          const patientId = this.investigation.patientID || this.investigation.patientId;

          let url = `Visits/GetPatientVisits`;
              url += `?CustomerID=${patientId}`;

          return this.$http
            .get(url)
            .then(({ data }) => {
              this.visits = data;
            })
            .catch(() => {});
        },

        fetchPatientBill() {
            this.$root.loading=true;
            Promise.all([this.fetchVisits(), this.fetchPatient(), ]).then(() => {
                this.$root.loading=false;
                this.viewBill=true;
            }).catch(() => {this.$root.loading=false;});
        },
    },

    components: {

        "discharge-bill-details": () => import('@/components/commons/billing/PerVisitPatientBillBreakdown.vue'),
        "claim-details": () => import('./ClaimDetails.vue'),
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-10/12">
  <template v-slot:title>
      <div class="w-full flex flex-wrap">
          <div class="flex-1 p-1">
              <h5 class="font-medium my-px" v-if="!investigation.verified && !investigation.priceDefined">
                  Not Verified </h5>
              <h5 class="font-medium my-px" v-if="investigation.verified && !investigation.priceDefined">
                  {{investigation.verified ? `Verified`: `Not Verified`}}</h5>
              <h5 class="font-medium my-px" v-if="investigation.priceDefined && !investigation.approved">
                  {{investigation.priceDefined ? `Price Defined`: `Not Defined`}}</h5>
              <h5 class="font-medium my-px" v-if="investigation.priceDefined && investigation.approved">
                  {{investigation.priceDefined ? `Approved`: ``}}</h5>
          </div>
          <div class="flex-1 text-right p-1">
              <button @click.prevent="fetchPatientBill"
                    class="btn-sm btn-info text-xs rounded">
                        <i class="fa fa-list"></i> Patient Bill</button>
          </div>
          <discharge-bill-details 
            :showModal="viewBill"
            :patient="{ ...patient, patientID: patient.patienT_ID, }"
            :visits="visits"
            @closeModal="viewBill=false"
          />
      </div>
    
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center my-1 bg-gray-200">
        <div class="md:w-1/3 w-1/2 p-3">
            Request ID: {{ investigation.patientLabResultId || investigation.invoiceDetailID }}
              <h5 class="font-medium text-sm capitalize">
                Test: {{!other ? investigation.test : investigation.service}}</h5>
        </div>
        <div class="md:w-1/3 w-1/2 p-3">
            <h5 class="font-medium text-sm capitalize">
                Patient: {{!other ? investigation.patient : investigation.names}}</h5>
        </div>
        <div class="md:w-1/6 w-1/3 p-3">
            <h5 class="font-medium text-sm capitalize">
              MRN: {{investigation.patientId || investigation.patientID}}</h5>
        </div>
        <div class="md:w-1/6 w-1/3 p-3">
            <h5 class="font-medium text-sm capitalize">
                OP File No: {{investigation.opfileno}}</h5>
        </div>
        <div class="md:w-1/6 w-1/3 p-3">
            <h5 class="font-medium text-sm capitalize">
                IP File No: {{investigation.ipfileno}}</h5>
        </div>
        <div class="md:w-1/6 w-1/3 p-3">
            <h5 class="font-medium text-sm capitalize">
                Status: {{investigation.patientstatus}}</h5>
        </div>
        <div class="md:w-1/5 w-1/3 p-3">
            <h5 class="font-medium text-sm capitalize">
                Payment Mode: {{investigation.paymentMode || `-`}}</h5>
        </div>
        <div class="md:w-1/3 w-full p-3">
            <h5 class="font-medium text-sm capitalize">
                Visit Payment Mode: {{investigation.pMode || investigation.pmode}}</h5>
        </div>
        <div class="md:w-1/6 w-1/3 p-3">
            <h5 class="font-medium text-sm capitalize">Age: {{investigation.age}}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-3" v-if="other">
            <h5 class="font-medium text-sm">Date: {{investigation.txnDate | dateFormat}}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-3" v-if="!other">
            <h5 class="font-medium text-sm">Request Date: {{investigation.date | dateFormat}}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-3" v-if="!other">
            <h5 class="font-medium text-sm">Done Date: {{(investigation.doneDate || investigation.doneOn) | dateFormat}}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-3" v-if="investigation.voided">
            <h5 class="font-medium text-sm">Returned By: {{investigation.voidedBy}}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-3" v-if="investigation.voided">
            <h5 class="font-medium text-sm">Returned On: {{investigation.voidedDate | dateFormat}}</h5>
        </div>
        <div class="w-1/2 p-3" v-if="investigation.voided">
            <h5 class="font-medium text-sm">Return Memo: {{investigation.voidComment || `-`}}</h5>
        </div>
    </div>
    <div class="w-full px-2 py-3 border-b border-t my-1"
        v-if="investigation.verified">
        <div class="w-full p-1">
            <h5 class="font-medium text-base uppercase">Verification Notes</h5>
        </div>
        <div class="w-full p-2">
            <p v-html="investigation.verificationInfo"></p>
        </div>
        <div class="w-full flex flex-wrap">
            <div class="flex-1">
                <h5 class="font-medium text-sm uppercase my-1">
                    Verified By: {{investigation.verifiedBy}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium text-sm uppercase my-1">
                    Verification Date: {{investigation.verifiedDate | dateFormat}}</h5>
            </div>
        </div>
    </div>
    <div class="my-1 w-full p-1" 
        v-if="consultantDetails.invoiceDetails && consultantDetails.invoiceDetails.length">
        <h5 class="font-medium text-base uppercase">Claim Details</h5>
    </div>
    <div class="w-full overflow-auto"
        v-if="consultantDetails.invoiceDetails && consultantDetails.invoiceDetails.length">
        <table class="table">
            <thead class="bg-blue-500 text-white font-medium">
                <tr>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Insurance</th>
                    <th class="p-tiny">Org Claim No</th>
                    <th class="p-tiny">Ref</th>
                    <th class="p-tiny">Preauth</th>
                    <th class="p-tiny">Comment</th>
                    <th class="p-tiny">CL No</th>
                    <th class="p-tiny">Amt</th>
                    <th class="p-tiny">User</th>
                </tr>
            </thead>
            <tbody class="bg-gray-100 text-xs">
                <tr 
                  v-for="(insurancePayment,idx) in consultantDetails.invoiceDetails" 
                  :key="`ins_${idx}`">
                    <td class="p-tiny">{{insurancePayment.item}}</td>
                    <td class="p-tiny">{{insurancePayment.organization}}</td>
                    <td class="p-tiny">{{insurancePayment.organizationClaimNo || `-`}}</td>
                    <td class="p-tiny">{{insurancePayment.invoiceNo}}</td>
                    <td class="p-tiny">{{insurancePayment.preAuthNo || `-`}}</td>
                    <td class="p-tiny w-56">{{insurancePayment.description || `-`}}</td>
                    <td class="p-tiny">
                        <h5 class="font-medium">{{ insurancePayment.claimNo || `-` }}</h5>
                        <button @click.prevent="insurancePayment.viewClaim = true"
                            class="btn-sm text-xs btn-info rounded">View</button>
                        <claim-details 
                            :showModal="insurancePayment.viewClaim"
                            :investigation="investigation" 
                            :claim="insurancePayment" 
                            @closeModal="insurancePayment.viewClaim = false"
                        />
                    </td>
                    <td class="p-tiny">{{insurancePayment.grandTotal | numberFormat}}</td>
                    
                    <td class="p-tiny">{{cashDetail.userName}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="my-1 w-full p-1 border-t" 
      v-if="consultantDetails.weiveredDetails && consultantDetails.weiveredDetails.length">
        <h5 class="font-medium text-base uppercase">Weiver Details</h5>
    </div>
    <div class="w-full overflow-auto" 
      v-if="consultantDetails.weiveredDetails && consultantDetails.weiveredDetails.length">
        <table class="table">
            <thead class="bg-blue-500 text-white">
                <tr>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Req Date</th>
                    <th class="p-tiny">Approval Date</th>
                    <th class="p-tiny">User</th>
                    <th class="p-tiny">Comment</th>
                    <th class="p-tiny">Weiver No</th>
                    <th class="p-tiny">Amount</th>
                    <th class="p-tiny">User</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(weiver,idx) in consultantDetails.weiveredDetails" 
                  :key="`weiver_${idx}`">
                    <td class="p-tiny">{{weiver.item}}</td>
                    <td class="p-tiny">{{weiver.txnDate | dateFormat}}</td>
                    <td class="p-tiny">{{weiver.dateApproved | dateFormat}}</td>
                    <td class="p-tiny">{{weiver.userName}}</td>
                    <td class="p-tiny">{{weiver.memo || `-`}}</td>
                    <td class="p-tiny">{{weiver.code}}</td>
                    <td class="p-tiny">{{weiver.weiveredAmount | numberFormat}}</td>
                    <td class="p-tiny">{{weiver.userName}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="my-1 w-full p-1 border-t" 
      v-if="consultantDetails.cashDetails && consultantDetails.cashDetails.length">
        <h5 class="font-medium text-base uppercase">Cash Payment</h5>
    </div>
    <div class="my-1 w-full overflow-auto" 
      v-if="consultantDetails.cashDetails && consultantDetails.cashDetails.length">
        <table class="table">
            <thead class="bg-blue-500 text-white">
                <tr>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Txn Date</th>
                    <th class="p-tiny">Receipt No</th>
                    <th class="p-tiny">Mode</th>
                    <th class="p-tiny">Price</th>
                    <th class="p-tiny">Paid Amt</th>
                    <th class="p-tiny">Balance</th>
                    <th class="p-tiny">User</th>
                    <th class="p-tiny">Print</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(cashDetail,idx) in consultantDetails.cashDetails" :key="`cash_${idx}`">
                    <td class="p-tiny">{{cashDetail.item}}</td>
                    <td class="p-tiny">{{cashDetail.date | dateFormat}}</td>
                    <td class="p-tiny">{{cashDetail.receiptNo}}</td>
                    <td class="p-tiny">{{cashDetail.mode}}</td>
                    <td class="p-tiny">{{(cashDetail.unitPrice * cashDetail.qty) | numberFormat}}</td>
                    <td class="p-tiny">{{cashDetail.paid | numberFormat}}</td>
                    <td class="p-tiny">{{cashDetail.balance | numberFormat}}</td>
                    <td class="p-tiny">{{cashDetail.userName}}</td>
                    <td class="p-tiny">
                        <button @click.prevent="printReceipt(investigation.patientId, cashDetail.receiptNo)"
                              class="btn-sm btn-info text-xs rounded">Receipt</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full flex flex-wrap border-b-2" 
        v-if="investigation.priceDefined">
        <div class="w-full p-2 my-1">
            <h5 class="font-medium text-base mb-2 uppercase">Price Definition</h5>
            <span v-html="investigation.priceDefinedInfo || `-`"></span>
        </div>
        <div class="w-full overflow-auto">
            <table class="table">
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Ref</th>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Consultant</th>
                        <th class="p-tiny">Memo</th>
                        <th class="p-tiny">Amount</th>
                        <th class="p-tiny">Status</th>
                    </tr>
                </thead>
                <tbody class="text-sm bg-gray-100">
                    <tr 
                        v-for="(consultantDetail,idx) in consultantDetails.consultantDetails" 
                        :key="idx">
                        <td class="p-tiny">{{consultantDetail.itemName}}</td>
                        <td class="p-tiny">{{consultantDetail.externalRef}}</td>
                        <td class="p-tiny">{{consultantDetail.trxDate | dateFormat}}</td>
                        <td class="p-tiny">{{consultantDetail.consultant}}</td>
                        <td class="p-tiny">{{consultantDetail.memo || `-`}}</td>
                        <td class="p-tiny">{{consultantDetail.amount | numberFormat}}</td>
                        <td class="p-tiny">{{consultantDetail.financeStatus }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="md:w-1/4 w-full p-2">
            <h5 class="font-medium text-base">
                Defined By: {{investigation.priceDefinedBy || `-`}}</h5>
        </div>
        <div class="md:w-1/4 w-full p-2">
            <h5 class="font-medium text-base">
                Definition Date: {{investigation.priceDefinedDate | dateFormat}}</h5>
        </div>
    </div>
    <div class="w-full p-2" v-if="investigation.approved">
        <h5 class="font-medium text-base">Approval Memo</h5>
        <p class="my-1">{{investigation.approvalComment || `-`}}</p>
    </div>
    <div class="w-full flex p-2" v-if="investigation.approved">
        <div class="flex-1">
            <h5 class="font-medium text-base">
                Approved By: {{investigation.approvedBy}}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-medium text-base">
                Approval Date: {{investigation.approvedDate | dateFormat}}</h5>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded" @click.prevent="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>